import React from 'react'
import about from 'views/ScanSettings/NewScan/about'
import styled from '@emotion/styled'
import { Light as SyntaxHighlighter } from 'react-syntax-highlighter'
import theme from 'react-syntax-highlighter/dist/esm/styles/hljs/tomorrow-night-blue'
import { PRE_SCAN_SELECTION, PRE_SCAN, SCAN_TYPE, SCAN } from 'views/ScanSettings/NewScan/constants'
import { UrecorderDownload } from 'components/UrecoderDownload';

const StyledListContainer = styled.ul`
	margin-left: 2.2rem;
  	list-style: circle;
`;

const StyledListItem = styled.li`
  list-style: circle;
  margin-bottom: 0.2rem;
  color: ${props => props.color || "black"};
  font-weight: ${props => props.bold || "normal"};
`;

const StyledText = styled.p`
  margin-top: 0.5rem;
`;


const HelpContent = ({ content }) => {
	const isValidContent = content && Array.isArray(content);
	return (
		<>
			{
				isValidContent && content.map((item, key) => {
					switch(item.type){
						case "text":
							return (<StyledText style={item.style ? item.style : null} key={key}>{item.content}</StyledText>);
						case "list":
							return (
								<StyledListContainer>
									{item.content.map((listItem, key) => (
										<StyledListItem color={item.color} bold={item.bold} key={key}>{listItem}</StyledListItem>
									))}
								</StyledListContainer>
							);
						case "recorder":
							return (<UrecorderDownload triggerText={item.content} />);
						default:
							return null;
					}
				})
			}
		</>
	)
}

const Help = ({ form, currentStep }) => {
	let subSectionKey = null
	const currentStepHelp = about.find(item => item.key === currentStep)
	if (!currentStepHelp) return null
	if (currentStep === PRE_SCAN) {
		subSectionKey = form.getFieldValue(PRE_SCAN_SELECTION)
	}
	if (currentStep === SCAN || currentStep === "simple") {
		subSectionKey = form.getFieldValue(SCAN_TYPE)
	}

	const { title, content, sections } = currentStepHelp
	const subSection = sections.find(section => section.key === subSectionKey)
	return (
		<div>
			<h2>{title}</h2>
			<HelpContent content={content}/>
			{subSection && (
				<div>
					<h2>{subSection.title}</h2>
					<HelpContent content={subSection.content}/>
					{subSection.links && (
						<div>
							<ul>
								{subSection.links.map((link, i) => (
									<li key={i}>
										<a href={link.url}>{link.title}</a>
									</li>
								))}
							</ul>
						</div>
					)}
					{subSection.code && (
						<SyntaxHighlighter language="json" style={theme}>
							{JSON.stringify(subSection.code, null, 2)}
						</SyntaxHighlighter>
					)}
				</div>
			)}
		</div>
	)
}

export default Help
